export interface Poi {
  id?: string;
  title: string;
  x: number;
  y: number;
  zoom: number;
}
